import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ACTION } from "./types";
import { goBack, navigation, needHelp, updateStateAction, } from "./actions";
import { ROUTE } from '../../routes';
import sharedPropsService from "../../SharedPropsService";
export const template = (height, data, initialStateValue) => {
    return {
        layout: {
            id: ROUTE.STATE_SELECTION,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: 'stateSelectionPage', type: WIDGET.STATE_SELECTION_PAGE }
            ]
        },
        datastore: {
            stateSelectionPage: {
                height: height,
                data: data,
                stateValue: initialStateValue,
                stateUpdateAction: {
                    type: ACTION.UPDATE_STATE,
                    routeId: ROUTE.STATE_SELECTION,
                    payload: {}
                },
                goBackAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.STATE_SELECTION,
                    payload: {}
                },
                needHelpAction: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.STATE_SELECTION,
                    payload: {}
                }
            }
        },
    };
};
export const stateSelectionMF = {
    onLoad: async ({ getHeight }, { stateDutyStamp }) => {
        const stateData = await sharedPropsService.getStampDutyData();
        const initialStateValue = stateDutyStamp;
        return Promise.resolve(template(getHeight(), stateData, initialStateValue));
    },
    actions: {
        [ACTION.NAVIGATION]: navigation,
        [ACTION.GO_BACK]: goBack,
        [ACTION.UPDATE_STATE]: updateStateAction,
        [ACTION.NEED_HELP]: needHelp,
    },
};
